import { DtoExt } from '@/classes/scenario/DtoExt';
import { ScenarioRenFrPV } from '@/dto/scenario/ren-fr/pv/ScenarioRenFrPV';

export class ScenarioRenFrPVExt extends DtoExt {

  public static fromDto(dto: ScenarioRenFrPV): ScenarioRenFrPVExt {
    return new ScenarioRenFrPVExt({
      unit_power: dto.unit_power,
      module_area: dto.module_area,
      p50_annual_degradation: dto.p50_annual_degradation,
      p90_annual_degradation: dto.p90_annual_degradation,
      installed_capacity: dto.installed_capacity,
      dc_ac_ratio: dto.dc_ac_ratio,
      net_p50: dto.net_p50,
      net_p90: dto.net_p90,
      numberOfPdl: dto.numberOfPdl,
      numberOfPdlPtr: dto.numberOfPdlPtr,
      numberOfPtr: dto.numberOfPtr
    });
  }

  public unit_power: number | null = null;
  public module_area: number | null = null;
  public p50_annual_degradation: number | null = null;
  public p90_annual_degradation: number | null = null;
  public installed_capacity: number | null = null;
  public dc_ac_ratio: number | null = null;

  public net_p50: number | null = null;
  public net_p90: number | null = null;

  public numberOfPdl: number | null = null;
  public numberOfPdlPtr: number | null = null;
  public numberOfPtr: number | null = null;

  constructor(options?: Partial<ScenarioRenFrPVExt> | null) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
    }
  }

  public toDto(): ScenarioRenFrPV {
    return new ScenarioRenFrPV({
      unit_power: this.unit_power,
      module_area: this.module_area,
      p50_annual_degradation: this.p50_annual_degradation,
      p90_annual_degradation: this.p90_annual_degradation,
      installed_capacity: this.installed_capacity,
      dc_ac_ratio: this.dc_ac_ratio,
      net_p50: this.net_p50,
      net_p90: this.net_p90,
      numberOfPdl: this.numberOfPdl,
      numberOfPdlPtr: this.numberOfPdlPtr,
      numberOfPtr: this.numberOfPtr
    });
  }
}
